<template>
  <div class="advertisement-wrapper">
    <template>
      <div class="article-wrapper">
        <div class="header">
          U Lifestyle 《社群》
        </div>
        <div>
          好消息！我們現已為品牌開通社群帳戶(ID:
          <span style="color:#164269;">{{ user.communityId }}</span>)
          。歡迎閣下使用公司電郵登入U Lifestyle App《社群》：
          <span style="color:#164269;">{{ user.communityEmail }}</span>
          分享品牌故事及最新內容！
        </div>
        <div class="bottom-wrapper">
          <div>
            <img style="background-size: 100%;"
              src="../../assets/img/notification/noti-phone-full.png"
            />
          </div>

          <div>
            <div class="content-border">
              <div style="width:100%; margin-right: 9px; color: #3596f4;">
                <div>立即掃瞄進入</div>
                <div>U Lifestyle App</div>
                <div>《社群》</div>
              </div>
              <div class="content-img d-flex justify-content-center">
                <img
                  src="../../assets/img/notification/noti-qr.png"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="button-wrapper">
          <b-button variant="primary"
            @click="$router.push({ name: 'Community' })">了解更多
          </b-button>
        </div>

      </div>
    </template>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue';

import { mapState } from 'vuex';

export default {
  components: {
    BButton,
  },
  computed: {
    ...mapState(['user']),
  },
};
</script>

<style scoped lang="scss">
.advertisement-wrapper {
  width: 60%;
  max-width: 373px;
  margin-right: 15px;
  height: 288px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #dde1e5;
  @include respond(tab-landscape) {
    max-width: unset;
    width: 100%;
    margin: 0px;
    flex-direction: column;
    height: auto;
    margin-bottom: 15px;
  }
  .article-wrapper {
    padding: 15px;
    padding-bottom: 0px;
    box-sizing: border-box;
    position: relative;

    // bottom-wrapper's parents
    height: 100%;
    display: flex;
    flex-direction: column;
    @include respond(tab-landscape) {
      width: 100%;
      padding-bottom: 15px;
    }
    .header {
      font-size: 18px;
      color: #174169;
      max-height: 26.5px;
      margin-bottom: 10px;
    }

    .button-wrapper {
      text-align: right;
      @include respond(tab-landscape) {
        text-align: center;
        height: auto;
        margin-top: 8px;
      }
      button {
        @include respond(tab-landscape) {
          width: 215px;
          position: inherit;
        }
        position: absolute;
        bottom: 10px;
        right: 15px;
        display: inline-block;
        width: 112px;
      }
    }
    .bottom-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      max-height: 120px;
      overflow: hidden;
      // child
      margin-top: auto;

      @include respond(tab-landscape) {
        height: auto;
        justify-content: center;
        align-items: end;
        max-height: none;
      }
      .content-img {
        position: relative;
      }
      .content-border {
        display: flex;
        flex-direction: row;
        max-width: 170px;
        max-height:70px;
        font-size: 12px;
        text-align: center;
        background: #fff;
        border-radius: 8px;
        border: 1px solid #dde1e5;
        padding: 7px 8.3px 6.3px 8px;
        position: relative;
        @include respond(tab-landscape) {
          flex-wrap: wrap;
          max-width: 109px;
          max-height:none;
          display: block;
          margin-left: 4px;
        }
      }
    }
  }
}
</style>
